import React from "react";
import ReactDOM from "react-dom/client";
import Home from "./page";
import { CookieNotice } from "../components/cookie-notice";
import { startPwa } from "../lib/pwa";
import "./theme.css";
import "./globals.css";
import "./vector.css";
import "./marketing.css";
import "./marketing-home.css";
import "./product.css";
import "./history.css";
import "./design-agent.css";
import "./showcase.css";
import "./design-only.css";
import "./cookie-notice.css";
import "./public-project.css";
import "./account.css";
startPwa(import.meta.env.PROD);
const root = document.getElementById("root")!;
const app = (
  <React.StrictMode>
    <BetaNotice />
    <Home />
    <CookieNotice />
  </React.StrictMode>
);
if (root.hasChildNodes()) ReactDOM.hydrateRoot(root, app);
else ReactDOM.createRoot(root).render(app);

function BetaNotice() {
  const [beta, setBeta] = React.useState(false);
  React.useEffect(() => setBeta(location.hostname === "beta.proximaforma.com"), []);
  return beta ? <div className="pf-beta-notice" role="status">Private beta · Test payments only</div> : null;
}
